// src/pages/onboarding/_shared/TapButton.jsx
import React from "react";

/** Fires immediately on mobile (pointerdown) and falls back to click on desktop. */
export default function TapButton({ onTap, className = "", children, ariaLabel }) {
  const ref = React.useRef(null);
  const handlePointerDown = (e) => {
    e.preventDefault();            // don’t blur input first
    e.stopPropagation();
    onTap?.(e);
  };
  const handleClick = (e) => {
    // in case a desktop click slips through
    e.preventDefault();
    e.stopPropagation();
    onTap?.(e);
  };
  return (
    <button
      ref={ref}
      type="button"
      aria-label={ariaLabel}
      onPointerDown={handlePointerDown}
      onClick={handleClick}
      className={className}
      style={{ width: 44, height: 44, borderRadius: 8, WebkitTapHighlightColor: "transparent" }}
    >
      {children}
    </button>
  );
}